import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Collapse, Nav, NavItem, Navbar, NavLink, NavbarBrand, NavbarToggler } from 'reactstrap'

class NavBar extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: true
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <Navbar color="dark" dark expand="md">
        <NavbarBrand href="/">Supplier Portal</NavbarBrand>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="mr-auto" navbar>
            <NavItem>
              <NavLink tag={Link} to="/">Jobs</NavLink>
            </NavItem>
            {this.props.user && this.props.user.id && !this.props.user.doesnotinvoiceus &&
            <NavItem>
              <NavLink tag={Link} to="/invoices">Invoices</NavLink>
            </NavItem>
            }
            <NavItem>
              <NavLink tag={Link} to="/account">Account</NavLink>
            </NavItem>
          </Nav>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <NavLink tag={Link} to="/logout">Log out</NavLink>
            </NavItem>

          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}


export default NavBar;



// WEBPACK FOOTER //
// ./src/NavBar.js